/* tslint:disable */
import { Store } from '@souche-f2e/muji';
const modules = {
    'abortiveAuction': require('../stores/abortiveAuction.tsx').default,
    'addPrice': require('../stores/addPrice.ts').default,
    'approve': require('../stores/approve.ts').default,
    'argueDetail': require('../stores/argueDetail.tsx').default,
    'argueRules': require('../stores/argueRules.tsx').default,
    'auctionOperate': require('../stores/auctionOperate.tsx').default,
    'auctionRules': require('../stores/auctionRules.tsx').default,
    'bidManageDetail': require('../stores/bidManageDetail.tsx').default,
    'bidSession': require('../stores/bidSession.tsx').default,
    'breakContract': require('../stores/breakContract.tsx').default,
    'brokeredDeal': require('../stores/brokeredDeal.tsx').default,
    'brokeredDealWinning': require('../stores/brokeredDealWinning.tsx').default,
    'buyer': require('../stores/buyer.ts').default,
    'carCene': require('../stores/carCene.ts').default,
    'carDetail': require('../stores/carDetail.ts').default,
    'carImgs': require('../stores/carImgs.tsx').default,
    'carOperate': require('../stores/carOperate.ts').default,
    'carState': require('../stores/carState.ts').default,
    'cashMargin': require('../stores/cashMargin.tsx').default,
    'cashTop': require('../stores/cashTop.tsx').default,
    'columnShow': require('../stores/columnShow.tsx').default,
    'companySet': require('../stores/companySet.tsx').default,
    'dealBreakContract': require('../stores/dealBreakContract.tsx').default,
    'dealDetail': require('../stores/dealDetail.tsx').default,
    'dealDispute': require('../stores/dealDispute.tsx').default,
    'dealFailCar': require('../stores/dealFailCar.ts').default,
    'depositConfig': require('../stores/depositConfig.tsx').default,
    'disputeManage': require('../stores/disputeManage.tsx').default,
    'formItem': require('../stores/formItem.ts').default,
    'global': require('../stores/global.tsx').default,
    'groupAccountDetail': require('../stores/groupAccountDetail.tsx').default,
    'groupAccountManage': require('../stores/groupAccountManage.tsx').default,
    'groupMoneyManage': require('../stores/groupMoneyManage.tsx').default,
    'home': require('../stores/home.ts').default,
    'info': require('../stores/info.tsx').default,
    'initiateDispute': require('../stores/initiateDispute.tsx').default,
    'longLinkListen': require('../stores/longLinkListen.ts').default,
    'margin': require('../stores/margin.tsx').default,
    'membersList': require('../stores/membersList.tsx').default,
    'moneyDetail': require('../stores/moneyDetail.tsx').default,
    'moneyManage': require('../stores/moneyManage.tsx').default,
    'normalDeal': require('../stores/normalDeal.tsx').default,
    'offerRecord': require('../stores/offerRecord.ts').default,
    'operating': require('../stores/operating.tsx').default,
    'payBuyer': require('../stores/payBuyer.tsx').default,
    'payMoneyModal': require('../stores/payMoneyModal.tsx').default,
    'paySeller': require('../stores/paySeller.tsx').default,
    'payTop': require('../stores/payTop.tsx').default,
    'playRules': require('../stores/playRules.ts').default,
    'priceGradient': require('../stores/priceGradient.ts').default,
    'priceTagList': require('../stores/priceTagList.ts').default,
    'priceVisibility': require('../stores/priceVisibility.tsx').default,
    'realtimeMonitoring': require('../stores/realtimeMonitoring.tsx').default,
    'recordDetail': require('../stores/recordDetail.tsx').default,
    'reportCreate': require('../stores/reportCreate.tsx').default,
    'reportList': require('../stores/reportList.tsx').default,
    'reserveTips': require('../stores/reserveTips.ts').default,
    'sceneManage': require('../stores/sceneManage.tsx').default,
    'scenePrint': require('../stores/scenePrint.ts').default,
    'screen': require('../stores/screen.tsx').default,
    'screenDetailLoop': require('../stores/screenDetailLoop.tsx').default,
    'screenLoop': require('../stores/screenLoop.tsx').default,
    'searchDealers': require('../stores/searchDealers.tsx').default,
    'seeDealInfo': require('../stores/seeDealInfo.ts').default,
    'seller': require('../stores/seller.tsx').default,
    'sellerPayConf': require('../stores/sellerPayConf.tsx').default,
    'sellerPayRules': require('../stores/sellerPayRules.ts').default,
    'session': require('../stores/session.ts').default,
    'showContract': require('../stores/showContract.tsx').default,
    'showTransferInfo': require('../stores/showTransferInfo.tsx').default,
    'shufflingPicture': require('../stores/shufflingPicture.tsx').default,
    'tenantsRules': require('../stores/tenantsRules.tsx').default,
    'transfer': require('../stores/transfer.tsx').default,
    'userInfo': require('../stores/userInfo.tsx').default,
    'waitPayCar': require('../stores/waitPayCar.tsx').default,
    'waitSign': require('../stores/waitSign.ts').default,
    'winBiddingCar': require('../stores/winBiddingCar.tsx').default
};
const storeConfig = {
    initialState: window['@@muji@storeInitialState'] || {},
    modules,
};
const store = new Store(storeConfig);
export default store;
export const { dispatch, getState } = store;
if (module.hot) {
    // save current state before module being reloaded
    module.hot.dispose(() => window['@@muji@storeInitialState'] = store.getState());
    module.hot.accept(['../stores/abortiveAuction.tsx'], () => {
        store.mount('abortiveAuction', require('../stores/abortiveAuction.tsx').default);
    });
    module.hot.accept(['../stores/addPrice.ts'], () => {
        store.mount('addPrice', require('../stores/addPrice.ts').default);
    });
    module.hot.accept(['../stores/approve.ts'], () => {
        store.mount('approve', require('../stores/approve.ts').default);
    });
    module.hot.accept(['../stores/argueDetail.tsx'], () => {
        store.mount('argueDetail', require('../stores/argueDetail.tsx').default);
    });
    module.hot.accept(['../stores/argueRules.tsx'], () => {
        store.mount('argueRules', require('../stores/argueRules.tsx').default);
    });
    module.hot.accept(['../stores/auctionOperate.tsx'], () => {
        store.mount('auctionOperate', require('../stores/auctionOperate.tsx').default);
    });
    module.hot.accept(['../stores/auctionRules.tsx'], () => {
        store.mount('auctionRules', require('../stores/auctionRules.tsx').default);
    });
    module.hot.accept(['../stores/bidManageDetail.tsx'], () => {
        store.mount('bidManageDetail', require('../stores/bidManageDetail.tsx').default);
    });
    module.hot.accept(['../stores/bidSession.tsx'], () => {
        store.mount('bidSession', require('../stores/bidSession.tsx').default);
    });
    module.hot.accept(['../stores/breakContract.tsx'], () => {
        store.mount('breakContract', require('../stores/breakContract.tsx').default);
    });
    module.hot.accept(['../stores/brokeredDeal.tsx'], () => {
        store.mount('brokeredDeal', require('../stores/brokeredDeal.tsx').default);
    });
    module.hot.accept(['../stores/brokeredDealWinning.tsx'], () => {
        store.mount('brokeredDealWinning', require('../stores/brokeredDealWinning.tsx').default);
    });
    module.hot.accept(['../stores/buyer.ts'], () => {
        store.mount('buyer', require('../stores/buyer.ts').default);
    });
    module.hot.accept(['../stores/carCene.ts'], () => {
        store.mount('carCene', require('../stores/carCene.ts').default);
    });
    module.hot.accept(['../stores/carDetail.ts'], () => {
        store.mount('carDetail', require('../stores/carDetail.ts').default);
    });
    module.hot.accept(['../stores/carImgs.tsx'], () => {
        store.mount('carImgs', require('../stores/carImgs.tsx').default);
    });
    module.hot.accept(['../stores/carOperate.ts'], () => {
        store.mount('carOperate', require('../stores/carOperate.ts').default);
    });
    module.hot.accept(['../stores/carState.ts'], () => {
        store.mount('carState', require('../stores/carState.ts').default);
    });
    module.hot.accept(['../stores/cashMargin.tsx'], () => {
        store.mount('cashMargin', require('../stores/cashMargin.tsx').default);
    });
    module.hot.accept(['../stores/cashTop.tsx'], () => {
        store.mount('cashTop', require('../stores/cashTop.tsx').default);
    });
    module.hot.accept(['../stores/columnShow.tsx'], () => {
        store.mount('columnShow', require('../stores/columnShow.tsx').default);
    });
    module.hot.accept(['../stores/companySet.tsx'], () => {
        store.mount('companySet', require('../stores/companySet.tsx').default);
    });
    module.hot.accept(['../stores/dealBreakContract.tsx'], () => {
        store.mount('dealBreakContract', require('../stores/dealBreakContract.tsx').default);
    });
    module.hot.accept(['../stores/dealDetail.tsx'], () => {
        store.mount('dealDetail', require('../stores/dealDetail.tsx').default);
    });
    module.hot.accept(['../stores/dealDispute.tsx'], () => {
        store.mount('dealDispute', require('../stores/dealDispute.tsx').default);
    });
    module.hot.accept(['../stores/dealFailCar.ts'], () => {
        store.mount('dealFailCar', require('../stores/dealFailCar.ts').default);
    });
    module.hot.accept(['../stores/depositConfig.tsx'], () => {
        store.mount('depositConfig', require('../stores/depositConfig.tsx').default);
    });
    module.hot.accept(['../stores/disputeManage.tsx'], () => {
        store.mount('disputeManage', require('../stores/disputeManage.tsx').default);
    });
    module.hot.accept(['../stores/formItem.ts'], () => {
        store.mount('formItem', require('../stores/formItem.ts').default);
    });
    module.hot.accept(['../stores/global.tsx'], () => {
        store.mount('global', require('../stores/global.tsx').default);
    });
    module.hot.accept(['../stores/groupAccountDetail.tsx'], () => {
        store.mount('groupAccountDetail', require('../stores/groupAccountDetail.tsx').default);
    });
    module.hot.accept(['../stores/groupAccountManage.tsx'], () => {
        store.mount('groupAccountManage', require('../stores/groupAccountManage.tsx').default);
    });
    module.hot.accept(['../stores/groupMoneyManage.tsx'], () => {
        store.mount('groupMoneyManage', require('../stores/groupMoneyManage.tsx').default);
    });
    module.hot.accept(['../stores/home.ts'], () => {
        store.mount('home', require('../stores/home.ts').default);
    });
    module.hot.accept(['../stores/info.tsx'], () => {
        store.mount('info', require('../stores/info.tsx').default);
    });
    module.hot.accept(['../stores/initiateDispute.tsx'], () => {
        store.mount('initiateDispute', require('../stores/initiateDispute.tsx').default);
    });
    module.hot.accept(['../stores/longLinkListen.ts'], () => {
        store.mount('longLinkListen', require('../stores/longLinkListen.ts').default);
    });
    module.hot.accept(['../stores/margin.tsx'], () => {
        store.mount('margin', require('../stores/margin.tsx').default);
    });
    module.hot.accept(['../stores/membersList.tsx'], () => {
        store.mount('membersList', require('../stores/membersList.tsx').default);
    });
    module.hot.accept(['../stores/moneyDetail.tsx'], () => {
        store.mount('moneyDetail', require('../stores/moneyDetail.tsx').default);
    });
    module.hot.accept(['../stores/moneyManage.tsx'], () => {
        store.mount('moneyManage', require('../stores/moneyManage.tsx').default);
    });
    module.hot.accept(['../stores/normalDeal.tsx'], () => {
        store.mount('normalDeal', require('../stores/normalDeal.tsx').default);
    });
    module.hot.accept(['../stores/offerRecord.ts'], () => {
        store.mount('offerRecord', require('../stores/offerRecord.ts').default);
    });
    module.hot.accept(['../stores/operating.tsx'], () => {
        store.mount('operating', require('../stores/operating.tsx').default);
    });
    module.hot.accept(['../stores/payBuyer.tsx'], () => {
        store.mount('payBuyer', require('../stores/payBuyer.tsx').default);
    });
    module.hot.accept(['../stores/payMoneyModal.tsx'], () => {
        store.mount('payMoneyModal', require('../stores/payMoneyModal.tsx').default);
    });
    module.hot.accept(['../stores/paySeller.tsx'], () => {
        store.mount('paySeller', require('../stores/paySeller.tsx').default);
    });
    module.hot.accept(['../stores/payTop.tsx'], () => {
        store.mount('payTop', require('../stores/payTop.tsx').default);
    });
    module.hot.accept(['../stores/playRules.ts'], () => {
        store.mount('playRules', require('../stores/playRules.ts').default);
    });
    module.hot.accept(['../stores/priceGradient.ts'], () => {
        store.mount('priceGradient', require('../stores/priceGradient.ts').default);
    });
    module.hot.accept(['../stores/priceTagList.ts'], () => {
        store.mount('priceTagList', require('../stores/priceTagList.ts').default);
    });
    module.hot.accept(['../stores/priceVisibility.tsx'], () => {
        store.mount('priceVisibility', require('../stores/priceVisibility.tsx').default);
    });
    module.hot.accept(['../stores/realtimeMonitoring.tsx'], () => {
        store.mount('realtimeMonitoring', require('../stores/realtimeMonitoring.tsx').default);
    });
    module.hot.accept(['../stores/recordDetail.tsx'], () => {
        store.mount('recordDetail', require('../stores/recordDetail.tsx').default);
    });
    module.hot.accept(['../stores/reportCreate.tsx'], () => {
        store.mount('reportCreate', require('../stores/reportCreate.tsx').default);
    });
    module.hot.accept(['../stores/reportList.tsx'], () => {
        store.mount('reportList', require('../stores/reportList.tsx').default);
    });
    module.hot.accept(['../stores/reserveTips.ts'], () => {
        store.mount('reserveTips', require('../stores/reserveTips.ts').default);
    });
    module.hot.accept(['../stores/sceneManage.tsx'], () => {
        store.mount('sceneManage', require('../stores/sceneManage.tsx').default);
    });
    module.hot.accept(['../stores/scenePrint.ts'], () => {
        store.mount('scenePrint', require('../stores/scenePrint.ts').default);
    });
    module.hot.accept(['../stores/screen.tsx'], () => {
        store.mount('screen', require('../stores/screen.tsx').default);
    });
    module.hot.accept(['../stores/screenDetailLoop.tsx'], () => {
        store.mount('screenDetailLoop', require('../stores/screenDetailLoop.tsx').default);
    });
    module.hot.accept(['../stores/screenLoop.tsx'], () => {
        store.mount('screenLoop', require('../stores/screenLoop.tsx').default);
    });
    module.hot.accept(['../stores/searchDealers.tsx'], () => {
        store.mount('searchDealers', require('../stores/searchDealers.tsx').default);
    });
    module.hot.accept(['../stores/seeDealInfo.ts'], () => {
        store.mount('seeDealInfo', require('../stores/seeDealInfo.ts').default);
    });
    module.hot.accept(['../stores/seller.tsx'], () => {
        store.mount('seller', require('../stores/seller.tsx').default);
    });
    module.hot.accept(['../stores/sellerPayConf.tsx'], () => {
        store.mount('sellerPayConf', require('../stores/sellerPayConf.tsx').default);
    });
    module.hot.accept(['../stores/sellerPayRules.ts'], () => {
        store.mount('sellerPayRules', require('../stores/sellerPayRules.ts').default);
    });
    module.hot.accept(['../stores/session.ts'], () => {
        store.mount('session', require('../stores/session.ts').default);
    });
    module.hot.accept(['../stores/showContract.tsx'], () => {
        store.mount('showContract', require('../stores/showContract.tsx').default);
    });
    module.hot.accept(['../stores/showTransferInfo.tsx'], () => {
        store.mount('showTransferInfo', require('../stores/showTransferInfo.tsx').default);
    });
    module.hot.accept(['../stores/shufflingPicture.tsx'], () => {
        store.mount('shufflingPicture', require('../stores/shufflingPicture.tsx').default);
    });
    module.hot.accept(['../stores/tenantsRules.tsx'], () => {
        store.mount('tenantsRules', require('../stores/tenantsRules.tsx').default);
    });
    module.hot.accept(['../stores/transfer.tsx'], () => {
        store.mount('transfer', require('../stores/transfer.tsx').default);
    });
    module.hot.accept(['../stores/userInfo.tsx'], () => {
        store.mount('userInfo', require('../stores/userInfo.tsx').default);
    });
    module.hot.accept(['../stores/waitPayCar.tsx'], () => {
        store.mount('waitPayCar', require('../stores/waitPayCar.tsx').default);
    });
    module.hot.accept(['../stores/waitSign.ts'], () => {
        store.mount('waitSign', require('../stores/waitSign.ts').default);
    });
    module.hot.accept(['../stores/winBiddingCar.tsx'], () => {
        store.mount('winBiddingCar', require('../stores/winBiddingCar.tsx').default);
    });
}
